/* eslint-disable react-hooks/exhaustive-deps */
import { makeStyles } from '@mui/styles';
import MenuItem from 'apollo-react/components/MenuItem';
import Select from 'apollo-react/components/Select';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useFormSelector } from '../../custom-hooks';
import { fetchDataSource } from '../../form-designer/actions/data-source.actions';
import { FormContext, SSGridContext } from '../../form-designer/context';
import { getFormModel } from '../../form-designer/selectors/common.selectors';
import { getDataSource } from '../../form-designer/selectors/form-manager.selectors';
import { equalityFn } from '../../form-designer/utils/form-manager.utils';
import { isNilOrEmpty } from '../../utils/ramdaUtils';

const useStyles = makeStyles({
  root: {
    marginTop: 0,
    marginBottom: 0,
    '& > div': {
      marginTop: 0,
    },
  },
});

const DataSourceDropdownFilter = ({ accessor, filters, updateFilterValue }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { rows, columns } = useContext(SSGridContext);
  const formKey = useContext(FormContext);
  const formModel = useFormSelector(getFormModel);
  const [options, setOptions] = useState([]);

  const { columnKey: currentColumnId } = columns.find((c) => c.accessor === accessor);
  const childControl = formModel[formModel[currentColumnId].childrenNodes[0]];
  const { dataSourceKey, dataTextField, dataValueField, entityName } = childControl;

  const dataSource = useFormSelector(getDataSource, { dataSourceKey }, equalityFn);

  const filteredOptions = useMemo(
    () =>
      options.filter((opt) => rows.some((row) => `${row[accessor]}` === `${opt[dataValueField]}`)),
    [options, rows]
  );

  useEffect(() => {
    if (!isNilOrEmpty(dataSource)) {
      dispatch(
        fetchDataSource({
          index: [0],
          dataSource,
          dataSourceFilterFromDataSource: dataSource.filter,
          formKey,
          entityName,
        })
      ).then((vals) => setOptions(vals.filter((item) => item[dataTextField])));
    }
  }, []);

  useEffect(() => {
    const filterValue = filters[accessor];

    if (!isNilOrEmpty(filterValue) && rows.every((row) => `${row[accessor]}` !== filterValue)) {
      updateFilterValue({ target: { name: accessor, value: '' } });
    }
  }, [filters, rows]);

  const handleChange = ({ target }) => {
    updateFilterValue({
      target: { name: accessor, value: `${target.value}` },
    });
  };

  return (
    <Select
      className={classes.root}
      fullWidth
      size="small"
      value={filters[accessor]}
      onChange={handleChange}
    >
      {filteredOptions.map((item, i) => (
        <MenuItem
          key={`${item[dataTextField]}_${item[dataValueField]}_${i}`}
          value={item[dataValueField]}
        >
          {item.LNG_TRANSLATION || item[dataTextField]}
        </MenuItem>
      ))}
    </Select>
  );
};

export default DataSourceDropdownFilter;
